const CATEGORIES = [
  {
    id: 1,
    key: 'administratif',
    label: 'Administratif',
    icon: 'o_folder',
    qColor: 'green-4',
    hex: '#79b09d',
    statuses: [
      { id: 1,  label: 'Dossier créé' },
      { id: 2,  label: 'Dossier incomplet' },
      { id: 3,  label: 'Pièces justificatives manquantes' },
      { id: 4,  label: 'Dossier complet' },
      { id: 5,  label: 'Dossier validé' },
      { id: 6,  label: 'Dossier rejeté (non conforme)' },
    ]
  },
  {
    id: 2,
    key: 'pedagogique',
    label: 'Pédagogique',
    icon: 'o_school',
    qColor: 'red-4',
    hex: '#d97a7a',
    statuses: [
      { id: 7,  label: 'Test de positionnement' },
      { id: 8,  label: 'Entretien pédagogique' },
      { id: 9,  label: 'Niveau validé' },
      { id: 10, label: 'Pré-requis non atteints' },
      { id: 11, label: 'Orientation vers une autre formation' },
    ]
  },
  {
    id: 3,
    key: 'selection',
    label: 'Sélection / Décision',
    icon: 'o_how_to_reg',
    qColor: 'secondary',
    hex: '#7eb5b5',
    statuses: [
      { id: 12, label: 'Candidature reçue' },
      { id: 13, label: "En cours d'étude" },
      { id: 14, label: 'Acceptée' },
      { id: 15, label: 'Refusée' },
      { id: 16, label: "En liste d'attente" },
    ]
  },
  {
    id: 4,
    key: 'financier',
    label: 'Financier',
    icon: 'o_euro',
    qColor: 'indigo-4',
    hex: '#6896d4',
    statuses: [
      { id: 17, label: 'Demande de financement en cours' },
      { id: 18, label: 'Financement accepté (CPF)' },
      { id: 19, label: 'Financement accepté (Pôle emploi)' },
      { id: 20, label: 'Financement accepté (entreprise)' },
      { id: 21, label: 'Financement accepté (région)' },
      { id: 22, label: 'Financement refusé' },
      { id: 23, label: 'Reste à charge candidat' },
      { id: 24, label: 'Convention signée' },
    ]
  },
  {
    id: 5,
    key: 'communication',
    label: 'Communication',
    icon: 'o_chat_bubble_outline',
    qColor: 'pink-3',
    hex: '#d396be',
    statuses: [
      { id: 25, label: 'Email envoyé' },
      { id: 26, label: 'Appel effectué' },   // était 24 (doublon corrigé)
      { id: 27, label: 'Relance envoyée' },
      { id: 28, label: 'Rendez-vous planifié' },
      { id: 29, label: 'Candidat injoignable' },
    ]
  },
  {
    id: 6,
    key: 'abandon',
    label: 'Abandon / Sortie',
    icon: 'o_exit_to_app',
    qColor: 'red-3',
    hex: '#e3a89d',
    statuses: [
      { id: 30, label: 'Abandon candidat' },      // était 27 (doublon corrigé)
      { id: 31, label: 'Désistement' },            // était 28 (doublon corrigé)
      { id: 32, label: 'Non présentation' },
      { id: 33, label: 'Report de candidature' },
      { id: 34, label: 'Formation annulée' },
    ]
  }
]

export const suiviCandidature = {
  namespaced: true,

  state: () => ({
    categories: CATEGORIES
  }),

  getters: {
    getSuiviCategories: (state) => state.categories,

    // Options pour le q-select "Catégorie" — value = id (number)
    getSuiviCategoryOptions: (state) =>
      state.categories.map((c) => ({
        label: c.label,
        value: c.id,
        icon:  c.icon,
        color: c.qColor
      })),

    // Options pour le q-select "Motif" — value = id (number)
    // Recherche par id de catégorie
    getSuiviStatusesByCategory: (state) => (categoryId) => {
      const cat = state.categories.find((c) => c.id === categoryId)
      if (!cat) return []
      return cat.statuses.map((s) => ({
        label: s.label,
        value: s.id
      }))
    },

    // Helpers de présentation — recherche par id de catégorie
    getSuiviCategoryHex:    (state) => (id) => state.categories.find((c) => c.id === id)?.hex    || '#9E9E9E',
    getSuiviCategoryQColor: (state) => (id) => state.categories.find((c) => c.id === id)?.qColor || 'grey',
    getSuiviCategoryIcon:   (state) => (id) => state.categories.find((c) => c.id === id)?.icon   || 'o_label',
    getSuiviCategoryLabel:  (state) => (id) => state.categories.find((c) => c.id === id)?.label  || '',

    // Retrouver le label d'un motif depuis son id (utile pour l'affichage en timeline)
    getSuiviMotifLabel: (state) => (motifId) => {
      for (const cat of state.categories) {
        const status = cat.statuses.find((s) => s.id === motifId)
        if (status) return status.label
      }
      return ''
    }
  },
}
